import { type FC, useState } from 'react';

import {
  type CompanyLogoSize,
  MONOGRAM_COLORS,
  Tile,
  TileImage,
  TileLetter,
} from './company-logo.styled';
import { getMonogram } from './get-monogram';

export type { CompanyLogoSize };

export type CompanyLogoProps = {
  name: string;
  src?: string | null;
  size?: CompanyLogoSize;
  loading?: boolean;
  className?: string;
};

export const CompanyLogo: FC<CompanyLogoProps> = ({
  name,
  src,
  size = 'md',
  loading = false,
  className,
}) => {
  const [loadedSrc, setLoadedSrc] = useState<string | null>(null);
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  const imageSrc = src && src !== failedSrc ? src : null;
  const isImageLoaded = imageSrc !== null && imageSrc === loadedSrc;
  const showMonogram = imageSrc === null && !loading;
  const { letter, colorIndex } = getMonogram(name, MONOGRAM_COLORS.length);

  return (
    <Tile
      $size={size}
      $monogramColor={showMonogram ? MONOGRAM_COLORS[colorIndex] : null}
      aria-hidden={isImageLoaded ? undefined : true}
      className={className}
    >
      {imageSrc !== null && (
        <TileImage
          key={imageSrc}
          src={imageSrc}
          alt={`${name} logo`}
          $loaded={isImageLoaded}
          onLoad={() => setLoadedSrc(imageSrc)}
          onError={() => setFailedSrc(imageSrc)}
        />
      )}
      {showMonogram && <TileLetter>{letter}</TileLetter>}
    </Tile>
  );
};
